import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function UpdateDestinationCatAndAsinlistService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/UpdateDestinationCatAndAsinlist`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        // notify.NotifySuccess("Selected fields has been updated successfully.");
            return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while Updating selected fields. please try again later.");
        return false;
    });
}

export default UpdateDestinationCatAndAsinlistService;